export const validateToken = (): boolean => {
  const token = localStorage.getItem("loginToken");
  if (!token) return false;
  
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp > Math.floor(Date.now() / 1000);
  } catch {
    return false;
  }
};

export const getLoggedInUser = (): { userId: number | null; username: string } => {
  const token = localStorage.getItem("loginToken");
  if (!token) return { userId: null, username: "" };
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return {
      userId: payload.userId ?? payload.id ?? payload.sub ?? null,
      username: payload.username ?? payload.sub ?? "",
    };
  } catch {
    return { userId: null, username: "" };
  }
};

const showSessionExpiryLoader = () => {
  const loaderDiv = document.createElement('div');
  loaderDiv.id = 'session-expiry-loader';
  loaderDiv.innerHTML = `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.7);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    ">
      <div style="
        width: 50px;
        height: 50px;
        border: 5px solid #f3f3f3;
        border-top: 5px solid #095179;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      "></div>
      <p style="color: #fff; margin-top: 20px; font-size: 16px;">
        Session expired. Redirecting to login...
      </p>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    </div>
  `;
  document.body.appendChild(loaderDiv);
};

export const redirectToLogin = (): void => {
  showSessionExpiryLoader();
  
  setTimeout(() => {
    localStorage.removeItem("loginToken");
    window.location.href = "/";
  }, 1500);
};

export const checkAuthAndRedirect = (): boolean => {
  if (!validateToken()) {
    redirectToLogin();
    return false;
  }
  return true;
};